// Este é o componente Message.js COMPLETO e ATUALIZADO
// Copie e cole todo o conteúdo abaixo no seu arquivo.

import React, { useState } from "react";
import style from "./MessageStyle";
import formatHelpers from "../../helpers/formatHelpers";
import { FiFileText } from "react-icons/fi";
import { obterMedia } from "../../../Services/dbservice";

const Message = ({ message }) => {
  // Estado para guardar a URL da mídia e controlar o carregamento
  const [mediaUrl, setMediaUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Verifica se a mensagem é uma notificação de mídia recebida
  const isMediaPlaceholder =
    message.text?.startsWith("[IMAGEM RECEBIDA]") && message.hasLink;
  // Extrai a legenda, se houver
  const caption = isMediaPlaceholder
    ? message.text.replace("[IMAGEM RECEBIDA]", "").trim()
    : null;

  // Função para buscar a mídia quando o link for clicado
  const handleMediaClick = async () => {
    if (!message.hasLink || isLoading || mediaUrl) return; // Evita cliques repetidos

    setIsLoading(true);
    try {
      const url = await obterMedia(message.hasLink, message.agentNumber);
      console.log(url)
      setMediaUrl(url);
    } catch (error) {
      console.error("Falha ao carregar mídia:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderMessageContent = () => {
    // Se a URL da mídia já foi carregada, mostra a imagem clicável
    if (mediaUrl) {
      return (
        <>
          {/* <-- MUDANÇA AQUI: Adicionamos a tag <a> --> */}
          <a href={mediaUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={mediaUrl}
              alt="Imagem recebida"
              style={style.imageContent}
            />
          </a>
          {caption && <div style={style.caption}>{caption}</div>}
        </>
      );
    }

    // Se for uma notificação de mídia, mostra o link clicável
    if (isMediaPlaceholder) {
      return (
        <>
          <span onClick={handleMediaClick} style={style.mediaLink}>
            {isLoading ? "Carregando imagem..." : "[IMAGEM RECEBIDA]"}
          </span>
          {caption && <span> {caption}</span>}
        </>
      );
    }

    // Lógica antiga para arquivos (pode ser adaptada se precisar)
    if (message.messageType === "file") {
      return (
        <div style={style.fileContainer}>
          <FiFileText size={24} style={style.fileIcon} />
          <div style={style.fileInfo}>
            <span style={style.fileName}>{message.messageContent}</span>
            <span style={style.fileMeta}>Arquivo</span>
          </div>
        </div>
      );
    }

    // Por padrão, retorna o texto normal da mensagem
    return message.text;
  };

  const isReply = message.isReply;

  return (
    <div
      style={{
        ...style.messageContainer,
        justifyContent: isReply ? "flex-end" : "flex-start",
      }}
    >
      <div
        style={{
          ...style.messageBox,
          ...(isReply ? style.replyBox : style.sentBox),
        }}
      >
        <div style={style.messageContent}>{renderMessageContent()}</div>
        <span style={style.messageTime}>
          {formatHelpers.formatarData(message.dateCreated)}
        </span>
      </div>
    </div>
  );
};

export default Message;
